export interface SuggestionEntry {
    count: number;
    name: string;
    uri: string;
}

const BASE_URL = import.meta.env.REACT_APP_SPOT_API_BASE_URL;

async function fetchIndex(path: 'photographers' | 'events'): Promise<SuggestionEntry[]> {
    if (!BASE_URL) return [];
    const response = await fetch(`${BASE_URL}/${path}/index.json`);
    if (!response.ok) {
        throw new Error(`A(z) ${path} javaslatainak betöltése sikertelen.`);
    }
    return response.json();
}

export function fetchPhotographerSuggestions(): Promise<SuggestionEntry[]> {
    return fetchIndex('photographers');
}

export function fetchEventSuggestions(): Promise<SuggestionEntry[]> {
    return fetchIndex('events');
}
